import { useState, useEffect, use } from "react";
import { useNavigate } from 'react-router-dom';

const GetCurrentUser = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [loggedInUser, setLoggedInUser] = useState(null);
    const [currentUser, setCurrentUser] = useState({});
    const navigate = useNavigate();

    const updateUserDetails = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetails"));
        if (userDetails) {
          setIsLoggedIn(true);
          setLoggedInUser(userDetails?.customer?.id);
          setCurrentUser(userDetails);
        } else {
          setIsLoggedIn(false);
          setLoggedInUser(null);
          setCurrentUser({});
        }
      };

      useEffect(() => {
        updateUserDetails();
      }, []);

    const loginUser = (userData) => {
        localStorage.setItem("userDetails", JSON.stringify(userData));
        updateUserDetails();
    };

    const logoutUser = () => {
        localStorage.removeItem("userDetails");
        setIsLoggedIn(false);
        setLoggedInUser(null);
        setCurrentUser({});
        navigate("/");
    };

    return { isLoggedIn, loggedInUser, loginUser, logoutUser, currentUser };
};

export default GetCurrentUser;
